import { Link, useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function LayoutProgramacionCamiones({ children }) {

  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const tabs = [
    { name: t("menu_listar_solicitud_programacion_camiones"), href: "viaje/listar-estado-solicitud-programacion-camiones" },
    { name: t("menu_listar_solicitud_producto"), href: "viaje/listar-estado-solicitud-producto" },
    // { name: t("menu_programacion"), href: "viaje/listar-programacion-solicitud-producto" },
    { name: t("menu_programacion_camiones_kanban"), href: "viaje/listar-programacion-camiones-kanban" },
    { name: t("menu_programacion_productos_kanban"), href: "viaje/listar-programacion-productos-kanban" },
  ].map((menuItem) => ({
    ...menuItem,
    getHref: () => (menuItem.primary ? `/` : `/${menuItem.href}`),
    current: function getCurrent(currentPath) {
      return currentPath === this.getHref();
    },
  }));

  function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }
  return (
    <div className="w-full">
      <div>
        <div className="sm:hidden">
          <label htmlFor="tabs" className="sr-only">
            Select a tab
          </label>
          {/* Use an "onChange" listener to redirect the user to the selected tab URL. */}
          <select
            id="tabs"
            name="tabs"
            className="block w-full rounded-md border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
            value={location.pathname}
            onChange={(e) => {
              history.push(e.target.value);
            }}
          >
            {tabs.map((tab) => (
              <option key={tab.name} value={tab.getHref()}>{tab.name}</option>
            ))}
          </select>
        </div>
        <div className="hidden sm:block">
          <div className="border-b border-gray-200">
            <nav className="-mb-px flex" aria-label="Tabs">
              {tabs.map((tab) => (
                <Link
                  to={'/' + tab.href}
                  className={classNames(
                    "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300",
                    "flex-1 py-4 px-1 text-center border-b-2 font-medium text-sm"
                  )}
                  key={"link-" + tab.name}
                >
                  {tab.name}
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </div>
      <div>{children}</div>
    </div>
  );
}
